// src/services/roleService.ts
import axios from "./axiosInstance";
import { RoleApiResponse, RolesApiResponse, RoleCreatePayload, PermissionsApiResponse } from "../types/roleTypes";

/**
 * List role for current instance (backend returns global + instance role).
 */
export const getRoles = async (params: Record<string, any>): Promise<RolesApiResponse> => {
  const response = await axios.get<RolesApiResponse>("/role", { params });
  return response.data;
};

/**
 * Create a role + attach its permissions in one call.
 * payload.permissionKeys like ["create::Message","read::Planner"]
 */
export const createRole = async (payload: RoleCreatePayload): Promise<RoleApiResponse> => {
  const response = await axios.post<RoleApiResponse>("/role", payload);
  return response.data;
};

/**
 * Delete a role (blocked by backend if system/superadmin/in-use/cross-instance).
 */
export const deleteRole = async (roleId: string): Promise<RoleApiResponse> => {
  const response = await axios.delete<RoleApiResponse>(`/role/${roleId}`);
  return response.data;
};

export const getDirectorPermissions = async (): Promise<PermissionsApiResponse> => {
  const res = await axios.get<PermissionsApiResponse>("/role/permissions/director");
  return res.data;
};

export const updateRole = async (roleId: string, payload: RoleCreatePayload): Promise<RoleApiResponse> => {
  const response = await axios.put<RoleApiResponse>(`/role/${roleId}`, payload);
  return response.data;
};
